import { PaymentTypeDto } from './dto/payment-type.dto';
import { Injectable } from '@angular/core';
import { IPaymentTypeService } from './ipayment-type.service';
import { ApiService, ApiCacheOptions } from '../../../shared/index';
import { PaymentTypeSearchDto } from './dto/payment-type-search.dto';

@Injectable({ providedIn: 'root' })
export class PaymentTypeService implements IPaymentTypeService {
  public _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public search(sarchParams: PaymentTypeSearchDto, ignoreCache = false) {
    let cacheOptions = this._cacheOptions;
    if (ignoreCache) {
      cacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
    }
    return this._apiService.getPaged(`PaymentTypes`, sarchParams, cacheOptions);
  }

  create(paymentType: PaymentTypeDto): any {
    return this._apiService.post(`PaymentType`, paymentType);
  }

  update(paymentType: PaymentTypeDto): any {
    return this._apiService.put(`PaymentType`, paymentType);
  }

  delete(paymentTypeId: number) {
    return this._apiService.delete(`PaymentType/${paymentTypeId}`);
  }

  public getPaymentTypes = (): Promise<Array<PaymentTypeDto>> => {
    return this._apiService.get('PaymentTypes/ActivePaymentTypes', this._cacheOptions).then((data: Array<PaymentTypeDto>) => {
      return Promise.resolve(data);
    });
  };

  public getCreditCardPaymentTypes = (): Promise<Array<PaymentTypeDto>> => {
    return this._apiService.get('PaymentTypes/ActivePaymentTypes', this._cacheOptions).then((data: Array<PaymentTypeDto>) => {
      let filter = data.filter((data) => data.CreditCardType == true);
      return Promise.resolve(filter);
    });
  };

  public getPaymentType = (paymentTypeId: number): Promise<PaymentTypeDto> => {
    return this._apiService.get('PaymentType/' + paymentTypeId.toString(), this._cacheOptions).then((data: PaymentTypeDto) => {
      return Promise.resolve(data);
    });
  };

  public getPaymentTypesForAccountingPackage = (accountingPackageId: number): Promise<Array<PaymentTypeDto>> => {
    return this._apiService
      .get('PaymentTypes/AccountingPackage/' + accountingPackageId.toString(), this._cacheOptions)
      .then((data: Array<PaymentTypeDto>) => {
        return Promise.resolve(data);
      });
  };

  public getPaymentTypesForRevenueItem = (revenueItemNum: number): Promise<Array<PaymentTypeDto>> => {
    return this._apiService
      .get('PaymentTypes/RevenueItem/' + revenueItemNum.toString(), this._cacheOptions)
      .then((data: Array<PaymentTypeDto>) => {
        return Promise.resolve(data);
      });
  };
}
